import { inactivityBlock } from '~/utils/inactivityBlockRegistry';

export async function runDownloadTask<T>(
  task: () => Promise<T>,
): Promise<T> {
  inactivityBlock.block();

  try {
    return await task();
  } finally {
    inactivityBlock.unblock();
  }
}
